// Judge.me Reviews Carousel
(function() {
  'use strict';

  let carouselInitialized = false;

  function initJudgemeCarousel() {
    // Éviter d'initialiser plusieurs fois
    if (carouselInitialized) return;

    // Trouver le container principal
    const mainContainer = document.querySelector('.jdgm-rev-widg__body');
    if (!mainContainer) {
      console.log('Judge.me carousel: Container principal non trouvé');
      return;
    }

    // Trouver le VRAI container des avis (celui qui contient directement les .jdgm-rev)
    const reviewContainer = mainContainer.querySelector('.jdgm-rev-widg__reviews') || mainContainer;

    const reviews = reviewContainer.querySelectorAll('.jdgm-rev');
    if (reviews.length <= 0) {
      console.log('Judge.me carousel: Aucun avis trouvé');
      return;
    }

    console.log(`Judge.me carousel: ${reviews.length} avis trouvés, initialisation...`);
    console.log('Container utilisé:', reviewContainer.className);
    carouselInitialized = true;

    // Masquer la pagination par défaut de Judge.me
    const judgeMePagination = document.querySelector('.jdgm-paginate') ||
                             document.querySelector('.jdgm-carousel-item-indicators');
    if (judgeMePagination) {
      judgeMePagination.style.display = 'none';
    }

    // FORCER les styles inline sur le BON container (celui qui contient les avis)
    reviewContainer.style.display = 'flex';
    reviewContainer.style.flexWrap = 'nowrap';
    reviewContainer.style.overflowX = 'auto';
    reviewContainer.style.scrollBehavior = 'smooth';
    reviewContainer.style.gap = '1.5rem';
    reviewContainer.style.paddingBottom = '1rem';
    reviewContainer.style.scrollbarWidth = 'none';
    reviewContainer.style.msOverflowStyle = 'none';

    // Forcer chaque avis
    reviews.forEach(review => {
      const visibleCount = getVisibleCount();
      const width = visibleCount === 3 ? 'calc(33.333% - 1rem)' :
                    visibleCount === 2 ? 'calc(50% - 0.75rem)' : '100%';
      review.style.flex = `0 0 ${width}`;
      review.style.minWidth = width;
      review.style.maxWidth = width;
    });

    // Wrapper pour le carousel (autour du container principal, pas le sous-container)
    const wrapper = document.createElement('div');
    wrapper.className = 'jdgm-carousel-wrapper';
    mainContainer.parentNode.insertBefore(wrapper, mainContainer);
    wrapper.appendChild(mainContainer);

    // Navigation
    const nav = document.createElement('div');
    nav.className = 'jdgm-carousel-nav';
    nav.innerHTML = `
      <button class="jdgm-carousel-btn jdgm-carousel-prev" aria-label="Previous">‹</button>
      <div class="jdgm-carousel-dots"></div>
      <button class="jdgm-carousel-btn jdgm-carousel-next" aria-label="Next">›</button>
    `;
    wrapper.appendChild(nav);

    const prevBtn = nav.querySelector('.jdgm-carousel-prev');
    const nextBtn = nav.querySelector('.jdgm-carousel-next');
    const dotsContainer = nav.querySelector('.jdgm-carousel-dots');

    // Calculer le nombre de pages
    function getVisibleCount() {
      if (window.innerWidth >= 1200) return 3;
      if (window.innerWidth >= 768) return 2;
      return 1;
    }

    let currentPage = 0;
    let visibleCount = getVisibleCount();
    let totalPages = Math.ceil(reviews.length / visibleCount);

    // Créer les dots
    function createDots() {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'jdgm-carousel-dot';
        if (i === 0) dot.classList.add('active');
        dot.setAttribute('aria-label', `Page ${i + 1}`);
        dot.addEventListener('click', () => goToPage(i));
        dotsContainer.appendChild(dot);
      }
    }

    // Aller à une page
    function goToPage(page) {
      if (page < 0 || page >= totalPages) return;

      currentPage = page;
      const scrollAmount = reviewContainer.scrollWidth / totalPages * page;
      reviewContainer.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });

      updateDots();
      updateButtons();
    }

    // Mettre à jour les dots
    function updateDots() {
      const dots = dotsContainer.querySelectorAll('.jdgm-carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentPage);
      });
    }

    // Mettre à jour les boutons
    function updateButtons() {
      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage === totalPages - 1;
    }

    // Navigation
    prevBtn.addEventListener('click', () => goToPage(currentPage - 1));
    nextBtn.addEventListener('click', () => goToPage(currentPage + 1));

    // Recalculer au resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newVisibleCount = getVisibleCount();
        if (newVisibleCount !== visibleCount) {
          visibleCount = newVisibleCount;
          totalPages = Math.ceil(reviews.length / visibleCount);
          currentPage = 0;

          // Réappliquer les styles aux avis
          reviews.forEach(review => {
            const width = newVisibleCount === 3 ? 'calc(33.333% - 1rem)' :
                          newVisibleCount === 2 ? 'calc(50% - 0.75rem)' : '100%';
            review.style.flex = `0 0 ${width}`;
            review.style.minWidth = width;
            review.style.maxWidth = width;
          });

          createDots();
          goToPage(0);
        }
      }, 250);
    });

    // Initialiser
    createDots();
    updateButtons();

    // Détecter le scroll manuel
    let scrollTimer;
    reviewContainer.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const scrollLeft = reviewContainer.scrollLeft;
        const pageWidth = reviewContainer.scrollWidth / totalPages;
        const newPage = Math.round(scrollLeft / pageWidth);
        if (newPage !== currentPage) {
          currentPage = newPage;
          updateDots();
          updateButtons();
        }
      }, 100);
    });
  }

  // Méthode 1: Mutation Observer pour détecter quand Judge.me charge
  const observer = new MutationObserver((mutations) => {
    if (carouselInitialized) {
      observer.disconnect();
      return;
    }

    const mainContainer = document.querySelector('.jdgm-rev-widg__body');
    if (!mainContainer) return;

    const reviewContainer = mainContainer.querySelector('.jdgm-rev-widg__reviews') || mainContainer;
    const reviews = reviewContainer.querySelectorAll('.jdgm-rev');

    if (reviews.length > 0) {
      console.log('Judge.me carousel: Avis détectés via MutationObserver');
      initJudgemeCarousel();
      observer.disconnect();
    }
  });

  // Observer tout le document pour les changements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Méthode 2: Tentatives répétées avec setTimeout
  let attempts = 0;
  const maxAttempts = 30; // 30 tentatives max (15 secondes)

  function tryInit() {
    if (carouselInitialized) return;

    const mainContainer = document.querySelector('.jdgm-rev-widg__body');
    if (mainContainer) {
      const reviewContainer = mainContainer.querySelector('.jdgm-rev-widg__reviews') || mainContainer;
      const reviews = reviewContainer.querySelectorAll('.jdgm-rev');

      if (reviews.length > 0) {
        console.log('Judge.me carousel: Avis détectés via setTimeout');
        initJudgemeCarousel();
        observer.disconnect();
        return;
      }
    }

    if (attempts < maxAttempts) {
      attempts++;
      setTimeout(tryInit, 500);
    } else {
      console.log('Judge.me carousel: Timeout - avis non trouvés après 15 secondes');
      observer.disconnect();
    }
  }

  // Démarrer les tentatives
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
